/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  InterestRateModel,
  InterestRateModelInterface,
  IInterestRateModel,
} from "../InterestRateModel";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_config",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidBeta",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKcrit",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKi",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKlin",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKlow",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRi",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTcrit",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTimestamps",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUcrit",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUlow",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUopt",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        indexed: false,
        internalType: "struct IInterestRateModel.Config",
        name: "config",
        type: "tuple",
      },
    ],
    name: "ConfigUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "ASSET_DATA_OVERFLOW_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RCOMP_MAX",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "X_MAX",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCompoundInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "ri",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "Tcrit",
        type: "int256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCompoundInterestRateWithOverflowDetection",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "ri",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "Tcrit",
        type: "int256",
      },
      {
        internalType: "bool",
        name: "overflow",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCurrentInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcur",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "config",
    outputs: [
      {
        internalType: "int256",
        name: "uopt",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "ucrit",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "ulow",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "ki",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "kcrit",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "klow",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "klin",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "beta",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "ri",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "Tcrit",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCompoundInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCompoundInterestRateAndUpdate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getConfig",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCurrentInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcur",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interestRateModelPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "overflowDetected",
    outputs: [
      {
        internalType: "bool",
        name: "overflow",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "setConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type InterestRateModelConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: InterestRateModelConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class InterestRateModel__factory extends ContractFactory {
  constructor(...args: InterestRateModelConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "InterestRateModel";
  }

  deploy(
    _config: IInterestRateModel.ConfigStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<InterestRateModel> {
    return super.deploy(_config, overrides || {}) as Promise<InterestRateModel>;
  }
  getDeployTransaction(
    _config: IInterestRateModel.ConfigStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_config, overrides || {});
  }
  attach(address: string): InterestRateModel {
    return super.attach(address) as InterestRateModel;
  }
  connect(signer: Signer): InterestRateModel__factory {
    return super.connect(signer) as InterestRateModel__factory;
  }
  static readonly contractName: "InterestRateModel";
  public readonly contractName: "InterestRateModel";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): InterestRateModelInterface {
    return new utils.Interface(_abi) as InterestRateModelInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): InterestRateModel {
    return new Contract(address, _abi, signerOrProvider) as InterestRateModel;
  }
}
